import React from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
export function TestimonialsBottom() {
  return <section className="w-full bg-alt-section py-20 px-6" data-id="element-147">
      <div className="max-w-[1000px] mx-auto" data-id="element-148">
        <h2 className="font-serif text-3xl md:text-4xl text-botanic text-center mb-16" data-id="element-149">
          Más historias de transformación
        </h2>

        {/* Featured Testimonial */}
        <motion.div whileHover={{
        y: -5
      }} className="bg-white p-8 md:p-12 rounded-2xl shadow-md border border-gold/20 mb-8 text-center max-w-3xl mx-auto" data-id="element-150">
          <div className="flex justify-center gap-1 mb-6" data-id="element-151">
            {[...Array(5)].map((_, j) => <Star key={j} className="w-6 h-6 fill-gold text-gold" data-id="element-152" />)}
          </div>
          <p className="text-ink text-lg md:text-xl italic mb-8 leading-relaxed" data-id="element-153">
            "Tenía insomnio crónico desde hace 5 años. Médicos, pastillas,
            meditación... nada funcionaba de verdad. Empecé con las cenas de
            Legado Salud y en 10 días noté la diferencia. Ahora duermo 7 horas
            seguidas. Esto cambió mi vida."
          </p>
          <div className="flex flex-col items-center gap-3" data-id="element-154">
            <div data-id="element-155">
              <p className="font-bold text-botanic text-lg" data-id="element-156">Sofía T.</p>
              <p className="text-ink-soft" data-id="element-157">55 años · Guadalajara</p>
            </div>
          </div>
        </motion.div>

        {/* Smaller Testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-158">
          <motion.div whileHover={{
          y: -5
        }} className="bg-white p-8 rounded-xl shadow-sm border border-gold/10" data-id="element-159">
            <div className="flex gap-1 mb-4" data-id="element-160">
              {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-gold text-gold" data-id="element-161" />)}
            </div>
            <p className="text-ink-soft italic mb-6" data-id="element-162">
              "Lo mejor es que no siento que estoy a dieta. Como rico, me siento
              satisfecho y duermo como no lo hacía desde los 30."
            </p>
            <div className="flex items-center gap-4" data-id="element-163">
              <div data-id="element-164">
                <p className="font-bold text-botanic" data-id="element-165">Manuel G.</p>
                <p className="text-sm text-ink-soft" data-id="element-166">51 años · Monterrey</p>
              </div>
            </div>
          </motion.div>

          <motion.div whileHover={{
          y: -5
        }} className="bg-white p-8 rounded-xl shadow-sm border border-gold/10" data-id="element-167">
            <div className="flex gap-1 mb-4" data-id="element-168">
              {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-gold text-gold" data-id="element-169" />)}
            </div>
            <p className="text-ink-soft italic mb-6" data-id="element-170">
              "El bono de la checklist nocturna me pareció increíble. Simple
              pero muy efectivo. Lo recomiendo a todas mis amigas de más de 45."
            </p>
            <div className="flex items-center gap-4" data-id="element-171">
              <div data-id="element-172">
                <p className="font-bold text-botanic" data-id="element-173">Lucía P.</p>
                <p className="text-sm text-ink-soft" data-id="element-174">48 años · Toluca</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}